import { render, staticRenderFns } from "./EndRecommendation.vue?vue&type=template&id=1783418e"
import script from "./EndRecommendation.vue?vue&type=script&lang=js"
export * from "./EndRecommendation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports